import Chip from '@mui/material/Chip';
import { ChipProps } from '@mui/material';
import React from 'react';

export function FilledChip({ children, ...props }: ChipProps): React.JSX.Element {
  return (
    <Chip variant='filled' {...props}>
      {children}
    </Chip>
  );
}

export default FilledChip;
